module.exports = __webpack_public_path__ + "img/Jh.c6d35feb.png";